import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type {
  APIResponse,
  MassTortNoteWithComments,
  MassTortTaskWithComments,
  MatterEvent,
} from "@/lib/types";

export type RetrieveMassTortCollectionParams = {
  massTortId: string;
  pageNumber?: number;
  pageSize?: number;
};

export const retrieveMassTortNotesV1 = (
  {
    massTortId,
    pageNumber = 1,
    pageSize = 50,
  }: RetrieveMassTortCollectionParams,
  signal?: AbortSignal,
) =>
  authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MassTortNoteWithComments[]>
    >(`matters/v1/mass-torts/${massTortId}/notes`, { params: { pageNumber, pageSize }, signal })
    .then((res) => res.data);

export const retrieveMassTortTasksV1 = (
  {
    massTortId,
    pageNumber = 1,
    pageSize = 50,
  }: RetrieveMassTortCollectionParams,
  signal?: AbortSignal,
) =>
  authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MassTortTaskWithComments[]>
    >(`matters/v1/mass-torts/${massTortId}/tasks`, { params: { pageNumber, pageSize }, signal })
    .then((res) => res.data);

export const retrieveMassTortEventsV1 = (
  {
    massTortId,
    pageNumber = 1,
    pageSize = 50,
  }: RetrieveMassTortCollectionParams,
  signal?: AbortSignal,
) =>
  authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MatterEvent[]>
    >(`matters/v1/mass-torts/${massTortId}/events`, { params: { pageNumber, pageSize }, signal })
    .then((res) => res.data);
